import qs from 'qs';
import { parseAttributeList } from '@/search-for-retail/attributes/attribute.parsers';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
// ---------------------------------------------------------------------------
// Endpoints
// ---------------------------------------------------------------------------
/**
 * RTK Query endpoints for the Attributes API.
 *
 * Endpoints sit under `/collections/{collection}/attributes`.
 * Auth and tenant headers are handled by the base `ccApi`.
 */
export const attributeApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        // -----------------------------------------------------------------------
        // Queries
        // -----------------------------------------------------------------------
        getAttributeList: builder.query({
            query: ({ collection, attributeGroup, page, perPage: size, sort, filter, }) => {
                const { propertyName, direction } = sort !== null && sort !== void 0 ? sort : {};
                const queryParams = qs.stringify({
                    attributeGroup,
                    page,
                    size,
                    sort: propertyName,
                    order: direction,
                    filters: filter,
                }, { allowDots: true });
                return `/collections/${collection}/attributes?${queryParams}`;
            },
            transformResponse: (response) => parseAttributeList(response),
            providesTags: (_result, _error, { collection, attributeGroup }) => [
                { type: CC_API_TAGS.AttributeList, id: `${collection}-${attributeGroup}` },
            ],
        }),
        getAttributeFullList: builder.query({
            query: ({ collection }) => `/collections/${collection}/attributes/short`,
            providesTags: (_result, _error, { collection }) => [
                { type: CC_API_TAGS.AttributeShortList, id: collection },
            ],
        }),
        getControlsCount: builder.query({
            query: ({ collection }) => `/collections/${collection}/attributes/count`,
            providesTags: (_result, _error, { collection }) => [
                { type: CC_API_TAGS.AttributeCount, id: collection },
            ],
        }),
        // -----------------------------------------------------------------------
        // Mutations
        // -----------------------------------------------------------------------
        updateAttributeList: builder.mutation({
            query: ({ collection, attributes }) => ({
                url: `/collections/${collection}/attributes`,
                method: 'PATCH',
                body: { items: attributes },
            }),
            transformResponse: (response) => parseAttributeList(response),
            invalidatesTags: (_result, _error, { collection }) => [
                // Invalidate all paginated attribute lists (any collection/group) since the
                // composite tag key makes scoped invalidation impractical.
                CC_API_TAGS.AttributeList,
                { type: CC_API_TAGS.AttributeShortList, id: collection },
                { type: CC_API_TAGS.AttributeCount, id: collection },
            ],
        }),
    }),
});
export const { useGetAttributeListQuery, useLazyGetAttributeListQuery, useGetAttributeFullListQuery, useLazyGetAttributeFullListQuery, useGetControlsCountQuery, useUpdateAttributeListMutation, } = attributeApi;
